import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=3d8ca652&scoped=true&"
import script from "./AudioControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AudioControl.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AudioControl.vue?vue&type=style&index=0&id=3d8ca652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ca652",
  null
  
)

export default component.exports